import React from "react";
import { VariantBase } from "~/components/newsletter/newsletter-widget/variants/component";
import { Container, theme } from "./styles";
export { config as newsletterListThemeConfig } from "./config";
export const NewsletterListTheme = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(VariantBase, {
  theme: theme,
  "data-qa": "newsletter-list-theme"
}, /*#__PURE__*/React.createElement(Container, props, children));
NewsletterListTheme.displayName = "NewsletterListTheme";